/**
 * The app's mobile-breakpoint hook: `true` below the token contract's `sm` breakpoint.
 *
 * `matchMedia` + `useSyncExternalStore`, so a component re-renders only when the viewport crosses
 * the breakpoint, never on every resize.
 */
import { useSyncExternalStore } from 'react';

/**
 * Widths strictly below `--breakpoint-sm` (768px in `src/index.css`), which is also where the `sm:`
 * utilities switch on. A media query cannot read a CSS variable, so the value is repeated here.
 */
const MOBILE_QUERY = '(max-width: 767.95px)';

const subscribe = (onChange: () => void): (() => void) => {
    const mql = window.matchMedia(MOBILE_QUERY);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
};

const getSnapshot = (): boolean => window.matchMedia(MOBILE_QUERY).matches;

// SSR / no-window fallback: never mobile (the app is a client SPA, so this is only a guard).
const getServerSnapshot = (): boolean => false;

export const useIsMobile = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
